import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useDashboardOrderRefs from '../../../../hooks/dashboard/useDashboardOrderRefs';

export const SearchComponent = ({ formData, setFormData, loading }) => {
  const { getReferences } = useDashboardOrderRefs();
  const [searchQuery, setSearchQuery] = useState(formData.searchFilter);
  const [options, setOptions] = useState([]);
  const [searchText, setSearchText] = useState(null);

  const handleSearch = async (text, reason) => {
    if (reason === 'clear' || !text) {
      setSearchQuery(null);
      setSearchText(null);
      setFormData((state) => ({
        ...state,
        searchFilter: null,
      }));
    } else {
      setSearchQuery(text);
    }
  };

  const handleChange = async (text) => {
    setSearchText(text);
    if (text?.length > 3) {
      const { references } = await getReferences({
        ...formData,
        searchFilter: text,
      });
      setOptions(references);
    } else {
      setOptions([]);
    }
  };

  useEffect(() => {
    if (options?.includes(searchQuery)) {
      setFormData((state) => ({
        ...state,
        searchFilter: searchQuery,
      }));
    }
  }, [searchQuery]);

  useEffect(() => {
    setSearchQuery(formData.searchFilter);
  }, [formData.searchFilter]);

  useEffect(() => {
    if (options?.includes(searchText)) {
      setSearchQuery(searchText);
    }
  }, [searchText]);

  return (
    <Box sx={{ width: '50%', padding: 3, display: 'flex', gap: 1 }}>
      <Autocomplete
        autoHighlight
        disablePortal
        options={options === undefined ? [] : options}
        getOptionLabel={(option) => option}
        onChange={(e, value, reason) => handleSearch(value, reason)}
        loading={loading}
        sx={{ width: '100%' }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Rechercher par numéro de commande"
            onChange={async (event) => await handleChange(event.target.value)}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: <>{params.InputProps.endAdornment}</>,
              },
            }}
          />
        )}
      />
      <Button variant="outlined" onClick={() => handleSearch(searchQuery, '')}>
        <SearchIcon fontSize="large" />
      </Button>
    </Box>
  );
};
